<template>
  <div>
    <v-snackbar
      v-model="isPaintingSimulacionSketch"
      bottom
      :timeout="-1"
    >
      Dibuja la zona de simulación
      <template
        #action="{ attrs }"
      >
        <v-btn
          text
          v-on="attrs"
          @click="stopSimulacionSketch"
        >
          Cancelar
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
      v-model="isLoadingSimulacion"
      bottom
      :timeout="-1"
    >
      Cargando simulación...
      <template
        #action="{ attrs }"
      >
        <v-progress-circular
          indeterminate
          v-on="attrs"
        />
      </template>
    </v-snackbar>

    <v-snackbar
      v-model="isErrorSimulacion"
      :color="errorSimulacion === 406 ? 'warning' : 'error'"
      bottom
      :timeout="3000"
    >
      <v-icon
        dark
      >
        mdi-alert-circle
      </v-icon>
      Advertencia en la simulación: {{ errorSimulacion === 404 ? 'no existe. En progreso o zona no combustible' :
        errorSimulacion === 406 ? 'en progreso' : 'error interno o simulación en zona no combustible' }}
    </v-snackbar>

    <vx-dialog-simulacion
      :show="showDialogSimulacion"
      :sim-mapa="simulacion"
      @deleteSimulacion="deleteSimulacionManager"
      @initSimulacionSketch="initSimulacionSketch"
      @paintSimulationSketch="paintSimulationSketch"
      @addPointSimulation="addPointSimulation"
      @redrawSimulationElements="redrawSimulationElements"
      @stopSimulacionSketch="stopSimulacionSketch"
      @endSimulacionSketch="endSimulacionSketch"
      @paintSimulacion="paintSimulacion"
      @paintViento="paintViento"
      @paintSimulacionEstadoFinal="paintSimulacionEstadoFinal"
      @open="openDialog"
      @close="closeDialog"
      @collapse-state-changed="handleCollapse"
    />
    <vx-simulacion-slider
      v-if="simulacion"
      v-show="isPaintingSimulacion"
      :simulacion="simulacion"
      @paintSimulacion="paintSimulacion"
      @updateSimulacionTime="updateSimulacionTime"
      @stopSimulacion="stopSimulacion"
    />
  </div>
</template>

<script>
import DialogSimulacion from './DialogSimulacion'
import SimulacionSlider from './SimulacionSlider'

import * as ArcGIS from '@/helpers/ArcGIS'
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'

export default {

  components: {
    'vx-dialog-simulacion': DialogSimulacion,
    'vx-simulacion-slider': SimulacionSlider
  },
  props: {
    showDialog: Boolean
  },

  data: () => ({
    showDialogSimulacion: false,

    isPaintingSimulacionSketch: false,

    isLoadingSimulacion: false,

    isPaintingSimulacion: false,
    simulacion: null,

    isErrorSimulacion: false,
    errorSimulacion: null,

    ultimo: null
  }),

  computed: {
    ...mapGetters({
      getSimulacionActiva: 'simulacion/activeSimulacion',
      cerrarSimulacionSliderValue: 'simulacion/cerrarSimulacionSlider'
    }),
    activeSimulacion() {
      return this.getSimulacionActiva
    }
  },

  watch: {
    showDialog() {
      this.showDialogSimulacion = this.showDialog
    },
    cerrarSimulacionSliderValue(value) {
      if (value) {
        this.stopSimulacion()
        this.setCerrarSimulacionSlider(false)
      }
    },
    activeSimulacion(simulacion) {
      if (simulacion) {
        const simulacionAux = {
          sim: JSON.parse(JSON.stringify(simulacion.sim)),
          id: simulacion.id
        }
        this.paintSimulacion(simulacionAux)
      }
    }
  },

  mounted() {
    this.$eventHub.$on('setSimulacionActiva', (simId) => {
      this.setSimulacionActiva(simId)
    })
  },

  methods: {
    ...mapActions('shareMap', [
      'updateSimulationTime',
      'clearSimulation'
    ]),

    ...mapActions('simulacion', {
      setCerrarSimulacionSlider: 'cerrarSimulacionSlider'
    }),

    ...mapActions('simulacion', [
      'deleteSimulacion'
    ]),

    openDialog() {
      this.$emit('openDialog')
      // this.showDialogSimulacion = true
    },
    closeDialog() {
      this.$emit('closeDialog')
      // this.showDialogSimulacion = false
    },
    handleCollapse(state) {
      this.$emit('collapse-state-changed', state)
    },

    initSimulacionSketch(data) {
      // Clear SVM y capa de dibujos anteriores
      ArcGIS.clearSimulacionSketch()

      this.isPaintingSimulacionSketch = true
      ArcGIS.initSimulacionSketchViewModel(data)
    },

    paintSimulationSketch(data) {
      this.isPaintingSimulacionSketch = true
      ArcGIS.initSimulacionSketchViewModel(data)
    },

    addPointSimulation(data) {
      ArcGIS.addPointElement(data)
    },

    redrawSimulationElements(data) {
      ArcGIS.drawSimulationElements(data)
    },

    stopSimulacionSketch() { // Finaliza el sketch
      this.isPaintingSimulacionSketch = false
      ArcGIS.stopSimulacionSketchViewModel()
      this.openDialog()
    },

    endSimulacionSketch() { // Finaliza el sketch
      this.isPaintingSimulacionSketch = false
      ArcGIS.stopSimulacionSketchViewModel()
      ArcGIS.clearSimulacionSketch()
    },

    async paintSimulacion(simulacion) {
      this.isLoadingSimulacion = true
      try {
        await ArcGIS.paintSimulacion(simulacion)
        if (simulacion.sim.simulacion.VIENTOS && simulacion.id === 'simulacion') {
          const viento = await this.paintViento(simulacion.sim)
          simulacion.sim.velocidades = {
            minSpeed: viento.minSpeed,
            maxSpeed: viento.maxSpeed
          }
        }

        this.isPaintingSimulacion = true
        this.simulacion = simulacion.sim
      } catch (err) {
        console.error('Error al pintar la simulacion:', err)
        this.isErrorSimulacion = true
        this.errorSimulacion = err // TODO: leer el mensaje del error, aqui llega el http code
        this.simulacion = null
      } finally {
        this.isLoadingSimulacion = false
      }
    },

    async paintViento(simulacion) {
      this.isLoadingSimulacion = true

      try {
        const flechas = await ArcGIS.paintViento({ sim: simulacion })
        if (simulacion.simulacion.TIPO === 'VIENTO') {
          simulacion.velocidades = {
            minSpeed: flechas[0].data.minSpeed,
            maxSpeed: flechas[0].data.maxSpeed
          }
          this.isPaintingSimulacion = true
          this.simulacion = simulacion
          ArcGIS.centerSimulacion(simulacion.simulacion.TIPO)
        }

        return flechas[0].data
      } catch (err) {
        console.error('Error al pintar la simulacion de viento:', err)
        this.isErrorSimulacion = true
        this.errorSimulacion = err
      } finally {
        this.isLoadingSimulacion = false
      }
    },

    async deleteSimulacionManager(data) {
      const simulacion = data.simulacion
      try {
        await this.deleteSimulacion(simulacion)
      } catch (error) {
        if (error.toJSON().status !== 404) {
          this.isErrorSimulacion = true
          this.errorSimulacion = error.toJSON().status // TODO: leer el mensaje del error, aqui llega el http code
          return
        }
      }

      // Si lo haces con la store en el front se ve mal
      // this.$store.dispatch('simulacion/deleteSimulacion', simulacion)

      data.callback()
    },

    async paintSimulacionEstadoFinal(data) {
      ArcGIS.clearSimulacion()
      let informe
      try {
        informe = await api.simulacion.getInformeSimulacion(
          data.simulacion.ID_SIMULACION
        )
      } catch (err) {
        console.error('Error paintEstadoFinal', err)
        this.isErrorSimulacion = true
        this.errorSimulacion = err // TODO: leer el mensaje del error, aqui llega el http code
        return
      }

      ArcGIS.paintSimulacionFinal(data.simulacion).then(async(error) => {
        if (error) {
          this.isErrorSimulacion = true
          this.errorSimulacion = error
          return
        }

        this.closeDialog()
        data.callback(informe.data)

        ArcGIS.clearSimulacion()
      }).catch((err) => {
        console.error(err)
        this.isErrorSimulacion = true
        this.errorSimulacion = err // TODO: leer el mensaje del error, aqui llega el http code
      }).finally(() => {
        this.isLoadingSimulacion = false
      })
    },

    async updateSimulacionTime(elapsedMin) {
      // Sharemap
      this.updateSimulationTime(elapsedMin)
      await ArcGIS.updateSimulacionTime(elapsedMin)
    },

    stopSimulacion() {
      try {
        this.isPaintingSimulacion = false
        this.simulacion = null
        this.clearSimulation()
        ArcGIS.clearSimulacion()
      } catch (error) {
        console.error('ERROR stopSimulacion', error)
      }
    },

    setSimulacionActiva(simId) {
      const sim = ArcGIS.getSimulacionById(simId)
      this.simulacion = sim?.sim
    }
  }
}
</script>

<style scoped></style>
